import { XIcon } from "lucide-react";
import { ReactNode } from "react";

import { Button } from "./ui/button";

type BannerProps = {
  text: ReactNode;
  ctaLink?: string;
  ctaAction?: () => void;
  ctaLinkTitle?: string;
  ctaActionTitle?: string;
  onClose?: () => void;
  leftOffset?: number;
};

export default function Banner({
  text,
  ctaLink,
  ctaAction,
  ctaLinkTitle,
  ctaActionTitle,
  onClose,
  leftOffset = 0,
}: BannerProps) {
  return (
    <header
      className="mt-1 mx-1 flex justify-center items-center gap-3 text-primary dark:text-primary-foreground border border-primary dark:border-primary-foreground w-fit py-1.5 px-3"
      style={{ left: `${leftOffset}px` }}
    >
      <p>{text}</p>
      {ctaLink && (
        <Button variant="default" size="sm" asChild>
          <a href={ctaLink} target="_blank">
            {ctaLinkTitle}
          </a>
        </Button>
      )}
      {ctaAction && ctaLink && <span>or</span>}
      {ctaAction && (
        <Button onClick={ctaAction} variant="default" size="sm">
          {ctaActionTitle}
        </Button>
      )}
      {onClose && (
        <button
          onClick={onClose}
          className="right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden [&_svg]:size-4"
          aria-label="Close banner"
        >
          <XIcon />
        </button>
      )}
    </header>
  );
}
